import { NavLink } from "react-router-dom";
import { Box } from "@mui/material";
import { linkStyle, menuIconStyle } from "./styles";
import type { MenuItemProps } from "./Sidebar";

export const SidebarMenuItem = ({ to, label, Icon, target, styles }: MenuItemProps) => (
  <Box sx={styles}>
    <NavLink to={to} className={({ isActive }) => (isActive ? "active" : "")} target={target}>
      <Box sx={linkStyle}>
        <Box sx={menuIconStyle}>{Icon && <Icon width="14" height="14" />}</Box>
        {label}
      </Box>
    </NavLink>
  </Box>
);
